import { desinscribirDeCurso } from "../Api/inscription";
import { useToastError } from "./useToast";
import { useAppDispatch } from "../app/store";
import { deleteUnsubProcessSectionId, setUnsubProcessSectionIds } from "../reduxSlices/subjectsSlice";

const useUnsubscribeSection = () => {
  const showError = useToastError();
  const dispatch = useAppDispatch();

  const handleBajaCurso = async (sectionId: number, anioLectivo: number): Promise<boolean> => {
    try {
      const idAlumnoPrograma = JSON.parse(localStorage.getItem("idAP") || "0");
      dispatch(setUnsubProcessSectionIds({ idCurso: sectionId, anioLectivo: anioLectivo }));
      const response = await desinscribirDeCurso(Number(idAlumnoPrograma), sectionId, anioLectivo);
      if (response.status === 200 && response.data.resultado >= 0) {
        console.log("CLOUD validations: OK");
        return true;
      } else {
        dispatch(deleteUnsubProcessSectionId({ idCurso: sectionId, anioLectivo: anioLectivo }));
        showError(response.data.mensaje);
        throw new Error("Request failed");
      }
    } catch (error) {
      return false;
    }
  };
  return handleBajaCurso;
};

export default useUnsubscribeSection;
